import React, { useEffect, useState } from 'react';
import { BaseTextField } from '../../UIWidgets';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from '@material-ui/core';
import SelectImageCard from '../imagePickerCard';
import { create_UUID } from 'utils/helpers';

const SubProductDialog = ({
	subProduct,
	isOpen,
	onClose,
	handleCreate,
	handleDelete,
}) => {
	const [open, setOpen] = useState(false);

	const [error, setError] = useState(false);

	const initialState = {
		uuid: create_UUID(),
		name: '',
		price: 0,
		numberOfStock: 0,
		image: [],
		...subProduct,
	};

	const [formValue, setFormValue] = useState(initialState);

	useEffect(() => {
		setOpen(isOpen);
		setFormValue(initialState);
	}, [isOpen, subProduct]);

	const handleClose = () => {
		onClose();
	};

	const handleConfirm = () => {
		if (formValue.name === '') {
			return setError(true);
		} else {
			setError(false);
		}

		if (formValue.image.length > 0) {
			handleCreate({
				...formValue,
				image: formValue.image[0],
			});
		} else {
			handleCreate({
				...formValue,
				image: { ...formValue.image },
			});
		}
		setFormValue({ name: '', price: 0, numberOfStock: 0, image: [] });
		onClose();
	};

	const handleDeleteClick = () => {
		if (formValue.image.length > 0) {
			handleDelete({
				...formValue,
				image: formValue.image[0],
			});
		} else {
			handleDelete({
				...formValue,
				image: { ...formValue.image },
			});
		}
		setFormValue({ name: '', price: 0, numberOfStock: 0, image: [] });
		onClose();
	};

	const handleChange = event => {
		setFormValue({
			...formValue,
			[event.target.name]: event.target.value,
		});
	};

	const handleSelectImage = images => {
		setFormValue({
			...formValue,
			image: images,
		});
	};

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby='form-dialog-title'
			>
				<DialogTitle id='form-dialog-title'>请给这个商品添加副商品</DialogTitle>
				<DialogContent>
					<BaseTextField
						title='副商品名称'
						name='name'
						value={formValue.name}
						onChange={handleChange}
						error={error}
					/>
					<BaseTextField
						title='实际价格'
						name='price'
						value={formValue.price}
						onChange={handleChange}
						type='number'
					/>
					<BaseTextField
						title='库存'
						name='numberOfStock'
						value={formValue.numberOfStock}
						onChange={handleChange}
						type='number'
					/>
					<SelectImageCard
						title='商品缩略图'
						subTitle='点击按钮上传商品的一张缩略图'
						images={formValue.image}
						handleSelect={handleSelectImage}
						multiple={false}
						handleClear={() => {
							setFormValue({
								...formValue,
								image: [],
							});
						}}
						limit={1}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleDeleteClick} color='secondary'>
						删除
					</Button>
					<Button onClick={handleClose} color='primary'>
						取消
					</Button>
					<Button onClick={handleConfirm} color='primary'>
						确定
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default SubProductDialog;
